// extracted by mini-css-extract-plugin
export default {"button":"InstructionButton_button__3lKNK","icon":"InstructionButton_icon__O3tlL"};